<template>
  <div class="h-full">
    <swiper-container
      ref="swiper"
      centered-slides="true"
      class="h-full"
      init="false"
      :autoplay-delay="
        !autoPlay ? 'null' : typeof autoPlay == 'number' ? autoPlay : 3000
      "
    >
      <swiper-slide
        v-for="(tabContent, i) in new Array(nbTabs).fill('')"
        :key="i"
        class="h-full"
      >
        <slot :data="{ position: i, isActive: activeTab == i }"></slot>
      </swiper-slide>
    </swiper-container>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Tabs',
  components: {},
  props: {
    nbTabs: {
      type: Number,
      default: 3,
    },
    allowTouchMove: {
      type: Boolean,
      default: true,
    },
    defaultTab: {
      type: Number,
      default: 0,
    },
    autoPlay: {
      type: [Boolean, Number],
      default: 100000000000000,
    },
  },
  data() {
    return {
      activeTab: 0,
      initiated: false,
    }
  },
  mounted() {
    this.initSlider()
    this.slideTo(this.defaultTab)
    this.initiated = true
  },
  beforeUnmount() {},
  methods: {
    initSlider() {
      const swiperComponent = this.$refs.swiper
      const params = {
        allowTouchMove: this.allowTouchMove,
        injectStyles: [
          `
        .swiper-pagination {
          margin-top:10px;
          position:relative;
          width: max-content!important;
          --swiper-pagination-bullet-width: 6px;
          --swiper-pagination-bullet-height: 6px;
          --swiper-pagination-bullet-inactive-opacity: 1;
          --swiper-pagination-bullet-inactive-color: red;
        }
      `,
          `
        .swiper-pagination-bullet {
          border: solid black 2px;
          background-color:transparent;
        }
      `,
          `
        .swiper-pagination-bullet-active {
          background-color: black
        }
      `,
        ],
      }

      Object.assign(swiperComponent, params)
      swiperComponent.initialize()
      const swiper = swiperComponent.swiper
      swiper.on('slideChange', () => {
        this.activeTab = swiper.activeIndex
      })
    },
    slideTo(tabIndex) {
      // const tabIndex = this.tabs.indexOf(newTab);
      // if (tabIndex < 0) return;
      const swiper = this.$refs.swiper?.swiper
      swiper?.slideTo(tabIndex, 300)
    },
    getActiveTab() {
      return this.activeTab
    },
    updateSlider() {
      this.$refs.swiper?.swiper?.update()
    },
  },
  watch: {
    activeTab(newValue) {
      if (!this.initiated) return
      this.$emit('tabChanged', newValue)
    },
    nbTabs() {
      this.updateSlider()
    },
  },
})
</script>
